// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    // ---------------------------------------------------
    // DECODIFICA TOKEN E SALVA USUÁRIO
    // ---------------------------------------------------
    const decodeToken = (token) => {
        try {
            const decoded = jwtDecode(token);
            setUser(decoded);
            setIsAuthenticated(true);
            localStorage.setItem('token', token);
        } catch (error) {
            console.error("Erro ao decodificar token:", error);
            logout();
        }
    };

    // ---------------------------------------------------
    // RESTAURA SESSÃO SE HOUVER TOKEN
    // ---------------------------------------------------
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            decodeToken(token);
        }
        setLoading(false);
    }, []);

    // ---------------------------------------------------
    // LOGIN COM MENSAGENS REAIS DO BACKEND
    // ---------------------------------------------------
    const login = async (email, password) => {
        try {
            const res = await api.post("/auth/login", { email, password });

            const token = res?.data?.token;

            if (!token) {
                throw new Error("Token não recebido.");
            }

            decodeToken(token);

            return true;
        } catch (err) {
            console.error("Erro no login:", err);

            // 🔥 Aqui está a correção importante
            const backendMessage =
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                "Erro ao tentar fazer login.";

            throw new Error(backendMessage);
        }
    };

    // ---------------------------------------------------
    // LOGOUT
    // ---------------------------------------------------
    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
        setIsAuthenticated(false);
    };

    // ---------------------------------------------------
    // VERIFICA ROLE
    // ---------------------------------------------------
    const hasRole = (roles) => {
        if (!user?.role) return false;
        const required = Array.isArray(roles) ? roles : [roles];
        return required.includes(user.role);
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                isAuthenticated,
                loading,
                login,
                logout,
                hasRole
            }}
        >
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
